import React, { useState } from "react";
import styles from "../loggedInHome.module.css";
import logo from "../../img/logo-small.png";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import {Link} from "react-router-dom";
import BillingComponent from "../loggedInComponents/billing";
import EditProfileComponent from "../loggedInComponents/editProfile";
import ProfileSharingComponent from "../loggedInComponents/profileSharing";
import GenerateCodeComponent from "./GenerateAccessCode";
import participants from "../../tempJSONFiles/participants.json"
import TempParticpantGrid from "./TempParticipantGrid";
import DashboardLink from "./DashboardLink";
import PasswordChange from "./PasswordChange";

const RDAAdminPage = () => {
    const [eventCache, setEventCache] = useState({});

    const fetchEventList = async (eventName) => {
        try {
            const response = await fetch(`/api/participants/${eventName}`);
            const data = await response.json();
            console.log("Participants List:", data.ids);
            return data.ids;
        } catch (error) {
            console.error("Error fetching from frontend:", error);
        }
    };
    
    const getParticipantList = async (eventKey) => {
        try {
            const response = await fetch(`/api/event-profiles/${eventKey}`);
            if (!response.ok) throw new Error('Network response was not ok');
            
            const data = await response.json();
            return data; 
        } catch (error) {
            console.error("Error fetching list:", error);
            return [];
        }
    };

    const [selection, setSelection] = useState("newCode");
    const handleLogout = () => {
            localStorage.removeItem("token");
            window.location.href = "/login"; 
        };


const handleChange = async (event, newSelection) => {
    if (newSelection !== null) {
        setSelection(newSelection);

        const eventKeys = {
            rosewell: "DCIRosewell26",
            lawrence: "DCILawrence26",
            carlisle: "DCICarlisle26",
            kingwood: "PWKingwood26"
        };

        const dbKey = eventKeys[newSelection];

        if (dbKey && !eventCache[newSelection]) {
            const data = await getParticipantList(dbKey);
            
            setEventCache(prev => ({
                ...prev,
                [newSelection]: data
            }));
        }
    }
};

const renderRightContent = () => {
    switch (selection) {
        case "newCode":
            return <GenerateCodeComponent />;
        case "dashboard":
            return <DashboardLink/>;
        case "changePassword":
            return<PasswordChange/>;
        case "rosewell":
            return <TempParticpantGrid participants={eventCache[selection] || []} event="Rosewell" />;
        case "lawrence":
            return <TempParticpantGrid participants={eventCache[selection] || []} event="Lawrence"/>;
        case "carlisle":
            return <TempParticpantGrid participants={eventCache[selection] || []} event="Carlisle" />;
        case "kingwood":
            return <TempParticpantGrid participants={eventCache[selection] || []} event="Kingwood" />;
        default:
            return <p>Select an option from the menu.</p>;
    }};
  const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    color:'white',
    fontSize:'20px',
    justifyContent: "flex-end",
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&.Mui-selected': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        color:'white'
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
    },
}));
const buttonStyles = {
  color: 'white',
  justifyContent: 'flex-end',
  fontSize:'20px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  }};

  return (
    <div className={styles.mainBox}>
      <div className={styles.leftSide}>
        <img src={logo} alt="Missing Logo" />

        <ToggleButtonGroup
          orientation="vertical"
          value={selection}
          exclusive
          onChange={handleChange}
          sx={{ mt: 2 }}
        >
            <CustomToggleButton value="newCode">Generate New Code</CustomToggleButton>
            <CustomToggleButton value="dashboard">Admin Dashboard</CustomToggleButton>
            <CustomToggleButton value="changePassword">Change Passsword</CustomToggleButton>
            {/* <CustomToggleButton value="rosewell">DCI Rosewell</CustomToggleButton>
            <CustomToggleButton value="lawrence">DCI Lawrence</CustomToggleButton>
            <CustomToggleButton value="carlisle">DCI Carlisle</CustomToggleButton>
            <CustomToggleButton value="kingwood">PW Kingwood</CustomToggleButton> */}
            
          
        </ToggleButtonGroup>
        <div className={styles.leftBottomButtons}>
            <div className={styles.partialBorder}/>
            <Button component={Link} to="/" sx={buttonStyles}>
                Home
            </Button>
            <Button variant="text" sx={buttonStyles} onClick={handleLogout}>
                Logout
            </Button>
            </div>
      </div>

      <div className={styles.rightSide}>
        <div className={styles.innerRight} >
            <Box sx={{width:"100%", overflow:"auto", justifyContent:"center", '&::-webkit-scrollbar': {
                display: 'none',
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
            }}>
                {renderRightContent()}
            </Box>
        </div>
      </div>
    </div>
  );
};

export default RDAAdminPage;